import React from "react";
import { BsPrefixComponent } from "react-bootstrap/esm/helpers";
import { FiUsers } from "react-icons/fi";
import { RiFilePaper2Line } from "react-icons/ri";
import Box from "../../Components/Box";
import Loading from "../../Components/Loading";
import { useAboutUs } from "./Hooks/index";

const AboutUs = () => {
  const { data, loading } = useAboutUs();
  if (loading) {
    return (
      <div className="about-us container">
        <Loading height={"400px"} />
      </div>
    );
  }
  const Data = [
    { lable: "تعداد آگهی ها", number: data?.count_ads || 30000, icon: "", icon: <RiFilePaper2Line size={30} /> },
    { lable: "تعداد کاربران", number: data?.count_user || 987000, icon: "", icon: <FiUsers size={30} /> }
  ];
  return (
    <div className="about-us container">
      <div className=" box">
        <div className="box2">
          <div>
            <img
              src={require("../../Assets/images/logo.png")}
              className="logo"
            />
            <div className="font mt-3">نیازمندی های رایگان صنعت</div>
          </div>

          <div className="left-side-img rounded shadow border">
            <img src={require("../../Assets/images/about.png")} />
          </div>
        </div>

        <div className="row d-flex justify-content-evenly">
          {Data.map((card) => {
            return (
              <Box
                icon={card.icon}
                lable={card.lable}
                number={card.number}
                col={"col-md-4 mt-2 mt-md-0"}
              />
            );
          })}
        </div>

        <h3 className="mt-5 mb-3">
          درباره صنعتبان
        </h3>
        <div className="text">{data?.text}</div>
      </div>
    </div>
  );
};

export default AboutUs;
